import React from "react";
import "./BadgeStatus.scss";
import AuiButton from "../Buttons/Buttons";
import TableStatus from "../TableStatus/TableStatus";
import { SessionStatusTypes} from "../../utils/constants/session-status-constants";
export type size = "small" | "medium";
export type Type = "admin" | "tenants" | "clients" | "others";
export interface BadgeStatusProps {
  data: any;
  size?: size;
  type?: Type;
  infoMessage?: any;
  tagid?: any;
  crossicon?: boolean;
  className?: string;
  reminder?: boolean;
  reminderTitle?: string;
  anchorlinkurl?: string;
  onClick?: any;
  children?: any;
  buttonClick?: () => void;
  buttonid?: any;
  disabled?: boolean;
  buttonclass?: any
}
const BadgeStatus = ({
  data,
  size = "small",
  type = "others",
  infoMessage,
  tagid,
  crossicon = false,
  className,
  reminder = false,
  reminderTitle = "Send Reminder",
  anchorlinkurl,
  onClick,
  children,
  buttonClick,
  buttonid,
  disabled,
  buttonclass
}: BadgeStatusProps) => {
  const handleClick = () => {
    if (buttonClick) {
      buttonClick();
    }
    const event = new Event("buttonClick");
    document.getElementById(buttonid)?.dispatchEvent(event);
  };
  return (
    <div className={`badgeStatus${className ? " " + className : ""}`}>
      <div className="mr-2 courseStatus"><TableStatus status={data as SessionStatusTypes} /></div>
      {infoMessage && <p className="pt-1" role="alert" aria-live="assertive">{infoMessage}</p>}
      <div className="reminder ml-2">
      {reminder &&
        (anchorlinkurl ? (
          <AuiButton
            variant="link-style-arrow"
            buttontitle={reminderTitle}
            modalid="exampleModal"
            size="small"
            anchorlinkurl={anchorlinkurl}
            buttonid={""}
            buttonClick={handleClick}
            disabled={disabled}
            buttonclass = {buttonclass}
          ></AuiButton>
        ) : (
          <AuiButton
            variant="link-style-arrow"
            buttontitle={reminderTitle}
            modalid="exampleModal"
            size="small"
            buttonClick={onClick}
            buttonid={""}
            buttonclass={buttonclass}
          ></AuiButton>
        ))}
      </div>

      {children && <div className="badgeChild">{children}</div>}
    </div>
  );
};

export default BadgeStatus;
